import { render, staticRenderFns } from "./ListCard.vue?vue&type=template&id=b4f71432&scoped=true&"
import script from "./ListCard.vue?vue&type=script&lang=js&"
export * from "./ListCard.vue?vue&type=script&lang=js&"
import style0 from "./ListCard.vue?vue&type=style&index=0&id=b4f71432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f71432",
  null
  
)

export default component.exports